import React, {ButtonHTMLAttributes} from 'react';

import cs from 'classnames';

import {gt} from 'app/utils/i18n';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  className?: string;
}

export function InviteNewMemberButton({
  label = gt('Invite new member'),
  className,
  ...props
}: Props) {
  return (
    <button className={cs('btn btn-link', className)} {...props}>
      {label}
    </button>
  );
}
